'use strict';

import React, { Component } from 'react'

import { search } from '@root/utility'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'
import Image     from '@Pure/Image'
import Link      from '@Pure/Link'
import Logo      from '@Pure/Logo'

const moment = window.moment;

const app = window.app;

const qwest = window.qwest;

export default class AdBlogsPage extends Component
{
	state =
	{
		data: [],
		references: [],

		pagination:
		{
			max_items: 30,
			limit: 30,
			skip: 0
		},

		searched:
		{
			value: ''
		}
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		component.fetchData();
	}

	fetchData = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		let filter_query =
		{
			sort: 'date DESC'
		};

		qwest.post('/CMS/getAll',
		{
			model: 'adblog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,

				data: (response.data || [])
				.filter(blog => [true, 'true'].includes(blog.disabled) === false)
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	getPagination = () =>
	{
		const component = this, props = this.props, config = this.props.config;

		let max_items = this.state.pagination.max_items;

		let total_items = component.state.data.length;

		let pagination = [];

		for (let i = 0; i < total_items; i += max_items)
		{
			let data =
			{
				items_count: (i + max_items > total_items)
				? (total_items - i)
				: (max_items),

				skip: i
			};

			data.limit = i + data.items_count;

			pagination.push(data);
		}

		pagination = pagination.map(function (data, index)
		{
			let is_active = component.state.pagination.limit === data.limit;

			let output =
			(
				<div key={ index } className={ 'c-pagination-item' +
					(is_active ? ' c-pagination-item--active' : '') }
					onClick={ function () { setPagination(data); } }>
					{ index + 1 }
				</div>
			);

			return output;
		});

		return pagination;

		function setPagination (data)
		{
			let pagination = Object.assign({ }, component.state.pagination);

			pagination.limit = data.limit;
			pagination.skip  = data.skip;

			component.setState({ pagination: pagination });
		}
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			searched:
			{
				value: value,
				data: (search ? search.data : undefined)
			}
		});

		app.emit('searchChange');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'Products'] }
				/>
			);
		}

		let data = state.data;

		if (component.state.searched.value !== '')
		{
			data = data.filter(function (article)
			{
				let matches = 0;

				['title']
				.forEach(function (field)
				{
					if (!article[field]) return;

					matches += search(article[field], component.state.searched.value);
				});

				article.__search_matches = matches;

				return matches > 0;
			})
			.sort(function (a, b)
			{
				return a.__search_matches > b.__search_matches;
			});
		}
		else
		{
			data = data
			.sort(function (a, b)
			{
				if (a.date > b.date)
				{
					return -1;
				}
				if (a.date === b.date)
				{
					return 0;
				}

				return 1;
			});
		}

		let articles = data
		.filter(function (element, index)
		{
			if (props.pagination === false)
			{
				return true;
			}

			return index < state.pagination.limit && index >= state.pagination.skip;
		})
		.map(function (article, key)
		{
			let img_url = article.images ? article.images[0] : null;

			if (img_url)
			{
				img_url = img_url.url;
			}

			if (!img_url)
			{
				img_url = article.images instanceof Array ? article.images[0] : null;

				img_url = img_url ? img_url.url : null;
			}

			let short_description = (article.content || '').split('<br>').join('');

			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } } />
			);

			const thumbnail = img_url ?
			(
				<Image className="c-model-preview__img"
					src={ img_url }
				/>
			)
			: <Logo type="svg" synergies />;

			let output =
			(
				<div className="c-model-preview-item article o-grid__item u-flex"
					key={ article.id + key }>

					<div className="c-model-preview c-model-preview--article">

						<div className="c-model-preview__thumb">

							<Link className="c-model-preview__thumb-link"
								href={ '/promotions/' + article.id }>
								{ thumbnail }
							</Link>

						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/promotions/' + article.id }
								className="c-model-preview__title-link">
								{ article.title }
							</Link>
						</h2>

						<div className="c-model-preview__themes">
							<div className="c-model-preview__theme">
								{ moment(article.date).format('DD MMMM YYYY') }
							</div>
						</div>

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							<div className="c-model-preview__buttons">
								<Link href={ '/promotions/' + article.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Voir l'article
								</Link>
							</div>

						</div>

					</div>

				</div>
			);

			return output;
		});

		let pagination = component.getPagination();

		if (pagination)
		{
			if (pagination.length <= 1 || state.searched.value !== '')
			{
				pagination = undefined;
			}
		}

		var output =
		(
			<Layout history={ props.history } page_title="En ce moment">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="front-dashboard-search">
							<SearchBar className="c-searchbar c-searchbar--front"
								hide_btn={ true } placeholder="Recherche..."
								data={ [] }
								handleChange={ component.handleSearch }
								value={ component.state.searched.value }
							/>
						</div>

						<div className="c-pagination u-margin-bottom-15">
							{ pagination }
						</div>

						<div className="u-negative-margin">

							<div className="o-grid-6 u-flex">
								{ loader || articles }
							</div>

						</div>

						<div className="c-pagination u-margin-top-15">
							{ pagination }
						</div>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}